
import OpenChatReportApi from '@/api/OpenChatReportApi'
import { getDateBetweenTwoDays, getTodayDate, getYesterdayDate } from '@/utils/date.util'
import { defineComponent, onBeforeUnmount, onMounted, reactive, ref } from 'vue'

export default defineComponent({
  setup () {
    let timer1 = 0
    let timer2 = 0
    let timer3 = 0
    let timer4 = 0
    let timer5 = 0
    const waitingNum = ref(0)
    const waitingData = reactive([
      {
        label: '在线会话请求数',
        value: 0,
        compare: 0
      },
      {
        label: '30s响应数',
        value: 0,
        compare: 0
      },
      {
        label: '在线会话漏接数',
        value: 0,
        compare: 0
      },
      {
        label: '在线会话接通率',
        value: 0,
        compare: 0,
        isPercentage: true
      }
    ])
    
    // 在线会话请求数
    function chatRequestCountReport () {
      const startDate = getYesterdayDate()
      const endDate = getTodayDate()
      const allDate = getDateBetweenTwoDays(startDate, endDate)
      OpenChatReportApi.chatRequestCountReport({
        startDate: startDate + ' 00:00:00',
        endDate: endDate + ' 23:59:59',
        groupTime: 'day'
      }).then((result: any) => {
        const list = allDate.map((date) => {
          const data = result.find((item) => item.time === date)
          if (data) {
            return data
          }
          return {
            count: 0,
            time: date
          }
        })
        const len = list.length
        const compare = list[len - 1].count - list[len - 2].count
        waitingData[0].value = list[len - 1].count
        waitingData[0].compare = compare
        timer1 = setTimeout(() => {
          chatRequestCountReport();
        }, 3000);
      })
    }

    // 30S响应数
    function chatRealResponseCountReport () {
      const startDate = getYesterdayDate()
      const endDate = getTodayDate()
      const allDate = getDateBetweenTwoDays(startDate, endDate)
      OpenChatReportApi.chatRealResponseCountReport({
        startDate: startDate + ' 00:00:00',
        endDate: endDate + ' 23:59:59',
        seconds: 30,
        groupTime: 'day'
      }).then((result: any) => {
        const list = allDate.map((date) => {
          const data = result.find((item) => item.time === date)
          if (data) {
            return data
          }
          return {
            count: 0,
            time: date
          }
        })
        const len = list.length
        const compare = list[len - 1].count - list[len - 2].count
        waitingData[1].value = list[len - 1].count
        waitingData[1].compare = compare
        timer2 = setTimeout(() => {
          chatRealResponseCountReport();
        }, 3000)
      })
    }

    // 在线会话漏接数
    function chatCancelCountReport () {
      const startDate = getYesterdayDate()
      const endDate = getTodayDate()
      const allDate = getDateBetweenTwoDays(startDate, endDate)
      OpenChatReportApi.chatCancelCountReport({
        startDate: startDate + ' 00:00:00',
        endDate: endDate + ' 23:59:59',
        groupTime: 'day'
      }).then((result: any) => {
        const list = allDate.map((date) => {
          const data = result.find((item) => item.time === date)
          if (data) {
            return data
          }
          return {
            count: 0,
            time: date
          }
        })
        const len = list.length
        const compare = list[len - 1].count - list[len - 2].count
        waitingData[2].value = list[len - 1].count
        waitingData[2].compare = compare
        timer3 = setTimeout(() => {
          chatCancelCountReport();
        }, 3000)
      })
    }

    // 在线会话接通率
    function chatResponsePercentageReport () {
      const startDate = getYesterdayDate()
      const endDate = getTodayDate()
      const allDate = getDateBetweenTwoDays(startDate, endDate)
      OpenChatReportApi.chatResponsePercentageReport({
        startDate: startDate + ' 00:00:00',
        endDate: endDate + ' 23:59:59',
        groupTime: 'day'
      }).then((result: any) => {
        const list = allDate.map((date) => {
          const data = result.find((item) => item.time === date)
          if (data) {
            return data
          }
          return {
            number: 0,
            requestCount: 0,
            responseCount: 0,
            time: date
          }
        })
        const len = list.length
        const compare = list[len - 1].number - list[len - 2].number
        waitingData[3].value = parseFloat((list[len - 1].number * 100).toFixed(2))
        waitingData[3].compare = parseFloat((compare * 100).toFixed(2))
        timer4 = setTimeout(() => {
          chatResponsePercentageReport();
        }, 3000)
      })
    }

    // 当前会话排队人数
    function chatLineUpReport () {
      OpenChatReportApi.chatLineUpReport()
        .then((res: any) => {
          waitingNum.value = res ? res.count : 0
          timer5 = setTimeout(() => {
            chatLineUpReport();
          }, 3000)
        })
    }

    onMounted(() => {
      chatRequestCountReport()
      chatRealResponseCountReport()
      chatCancelCountReport()
      chatResponsePercentageReport()
      chatLineUpReport()
    })
    
    onBeforeUnmount(() => {
      clearTimeout(timer1)
      clearTimeout(timer2)
      clearTimeout(timer3)
      clearTimeout(timer4)
      clearTimeout(timer5)
    })

    return {
      waitingNum,
      waitingData
    }
  }
})
